import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { TokenInterceptor } from "./services/interceptors/token-interceptor.service";
import { LoadingInterceptor } from './services/interceptors/loading-interceptor.service';
import { LocalizedDatePipe } from "./pipes/localized-date.pipe";
import { ConfirmModalComponent } from "./components/confirm-modal/confirm-modal.component";
import { ToastContainerComponent } from "./components/toast-container/toast-container.component";
import { ConfirmModalService } from "./services/confirm-modal.service";
import { BlobService } from "./services/blob.service";
import { ToastService } from "./services/toast.service";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    LocalizedDatePipe,
    ConfirmModalComponent,
    ToastContainerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    NgbModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    NgbModule,
    TranslateModule,
    LocalizedDatePipe,
    ToastContainerComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    ConfirmModalService,
    BlobService,
    ToastService
  ]
})
export class SharedModule {}
